import { Route } from 'react-router-dom';

import { PromotionDetailPage } from './pages/promotion-detail-page.js';
import { PromotionFormPage } from './pages/promotion-form-page.js';
import { PromotionListPage } from './pages/promotion-list-page.js';

export function promotionRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/promotions" element={<PromotionListPage />} />
      <Route path="/promotions/new" element={<PromotionFormPage />} />
      <Route path="/promotions/:promotionId" element={<PromotionDetailPage />} />
      <Route path="/promotions/:promotionId/edit" element={<PromotionFormPage />} />
    </>
  );
}
